import React from "react";
import BaseCard from "./BaseCard";
import "./MetricCard.css";

/**
 * MetricCard
 * Dashboard metric tile with large number, label, optional icon and trend.
 *
 * Props:
 * - label: string
 * - value: ReactNode
 * - icon?: ReactNode
 * - tone?: "default" | "primary" | "success" | "warning" | "danger"
 * - trend?: { value: string, direction?: "up" | "down" | "neutral" }
 * - size?: "md" | "lg"
 * - onClick?: () => void
 */
function MetricCard({
  label,
  value,
  icon,
  tone = "default",
  trend,
  size = "md",
  onClick,
}) {
  const clickable = typeof onClick === "function";

  return (
    <BaseCard
      className={`metric-card metric-${tone} metric-${size}`}
      clickable={clickable}
      onClick={onClick}
    >
      <div className="metric-card-top">
        {icon && <div className="metric-icon">{icon}</div>}
        <div className="metric-label">{label}</div>
      </div>
      <div className="metric-value-row">
        <div className="metric-value">{value}</div>
        {trend && trend.value && (
          <div
            className={`metric-trend metric-trend-${
              trend.direction || "neutral"
            }`}
          >
            <span className="metric-trend-arrow">
              {trend.direction === "up"
                ? "▲"
                : trend.direction === "down"
                  ? "▼"
                  : "•"}
            </span>
            <span className="metric-trend-value">{trend.value}</span>
          </div>
        )}
      </div>
    </BaseCard>
  );
}

export default MetricCard;

